import clsx from "clsx";
import { Filters } from "../../../../../lib/filters";
import { PeopleHorizontalFilters } from "../../../../../lib/filters/accordion/horizontalFiltersPerson";
import { ContactType, FindAllContactsFilters, FindContactsTargetResponse } from "../../../../../lib/filters/dto";
import { useAppSelector } from "../../../../../lib/redux/hooks";
import { ContactsCounterDTO } from "../../../contacts/dto";
import { TargetPeopleList } from "./list";
import { TargetListDTO } from "../../../dto";
import { ProjectDTO } from "../../../../projects/dto";
import { EmailsMessagesDTO, FindAllCustomMailsResponseDTO } from "../../../../projects/mails/dto";

interface Props {
  toActivate: number
  showPopup: boolean
  setShowPopup: (action: boolean) => void
  selectedIds: { contactId: string, personId: string }[]
  setSelectedIds: (action: { contactId: string, personId: string }[]) => void
  filters: FindAllContactsFilters
  setFilters: (action: Partial<FindAllContactsFilters>) => void
  setPage: (action: number) => void
  resetFilters: () => void
  contacts: FindContactsTargetResponse<ContactType.PERSON>
  counters: ContactsCounterDTO
  targetList: TargetListDTO
  project: ProjectDTO
  isLoadingEmailsHistory: boolean
  emailsHistory: { messages: EmailsMessagesDTO[] }
  templates: FindAllCustomMailsResponseDTO
}

export function TargetListPeopleList(props: Props) {
  const { selectedIds, counters, setSelectedIds, setShowPopup, showPopup, setFilters, setPage, resetFilters, filters, contacts, toActivate, targetList, project, isLoadingEmailsHistory, emailsHistory, templates } = props
  const databaseState = useAppSelector((state) => state.database);
  return (
    <div className="max-h-full rounded-2xl w-full flex h-full">
      <div className="flex rounded-2xl w-full">
        <div
          className={clsx("transition-all duration-300 w-[20%] h-full opacity-100 rounded-bl-xl", {
            flex: databaseState.filtersActive,
            hidden: !databaseState.filtersActive,
          })}
        >
          <Filters
            section="target"
            contactType={ContactType.PERSON}
            isInTargetList={true}
            resetFilters={() => resetFilters()}
            filters={filters}
            updateFilters={arg => setFilters(arg)}
          />
        </div>
        <div
          className={clsx({
            "w-full": !databaseState.filtersActive,
            "w-4/5": databaseState.filtersActive,
          })}
        >
          <div className="h-full">
            <PeopleHorizontalFilters
              onChangeFilters={(arg) => setFilters(arg)}
              filters={filters}
              toActivate={toActivate}
              isInTargetList={true}
            />
            <TargetPeopleList
              section="target"
              isLoadingEmailsHistory={isLoadingEmailsHistory}
              emailsHistory={emailsHistory}
              project={project}
              targetList={targetList}
              counters={counters}
              templates={templates}
              contacts={contacts}
              selectedIds={selectedIds}
              setSelectedIds={arg => setSelectedIds(arg)}
              setShowPopup={arg => setShowPopup(arg)}
              showPopup={showPopup}
              filters={filters}
              setFilters={function (action: Partial<FindAllContactsFilters>): void {
                setFilters(action);
              }}
              setPage={function (action: number): void {
                setPage(action);
              }}
              resetFilters={function (): void {
                resetFilters()
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
